// Firebase v8 (compatível com TypeScript 3.7)
import firebase from 'firebase/app';
import 'firebase/messaging';

// Usar variável de ambiente ou URL relativa
const API_URL = process.env.REACT_APP_API_URL || window.location.origin + '/api';

// Configuração Firebase (substituir pelos seus valores)
const firebaseConfig = {
  apiKey: "AIzaSyBvNcLb4gJhN5pyJgeQMmjEaUHj2NBY2Nw",
  authDomain: "teste-notification-95a6b.firebaseapp.com",
  projectId: "teste-notification-95a6b",
  storageBucket: "teste-notification-95a6b.firebasestorage.app",
  messagingSenderId: "1067268446228",
  appId: "1:1067268446228:web:bcfd3cdd2f32c19fc2ef01",
  measurementId: "G-L5X33DEQ1Q"
};

let messagingInstance: any = null;
let serviceWorkerRegistration: ServiceWorkerRegistration | null = null;

// Registrar Service Worker
export const registerServiceWorker = async (): Promise<ServiceWorkerRegistration | null> => {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js', {
        scope: '/',
      });
      console.log('✅ Service Worker registrado com sucesso:', registration.scope);
      serviceWorkerRegistration = registration;
      return registration;
    } catch (error) {
      console.error('❌ Erro ao registrar Service Worker:', error);
      return null;
    }
  }
  console.warn('⚠️ Service Worker não suportado neste navegador');
  return null;
};

export const initFirebase = async () => {
  try {
    if (!firebase.apps.length) {
      firebase.initializeApp(firebaseConfig);
    }
    messagingInstance = firebase.messaging();
    
    // IMPORTANTE: Desabilitar notificações automáticas do Firebase
    // Quando o payload tem 'notification', o Firebase pode mostrar automaticamente
    // Precisamos garantir que apenas o service worker mostra notificações
    // O Firebase v8 não tem uma opção direta para desabilitar, mas podemos garantir
    // que o handler onMessage não mostra notificações automaticamente
    
    // Garantir que o service worker está registrado
    if (!serviceWorkerRegistration) {
      await registerServiceWorker();
    }
    
    return messagingInstance;
  } catch (error) {
    console.error('Erro ao inicializar Firebase:', error);
    return null;
  }
};

export const getNotificationPermission = (): NotificationPermission | null => {
  if (!('Notification' in window)) {
    return null;
  }
  return Notification.permission;
};

export const requestNotificationPermission = async (): Promise<boolean> => {
  if (!('Notification' in window)) {
    console.log('Este navegador não suporta notificações');
    return false;
  }
  
  if (Notification.permission === 'granted') {
    return true;
  }
  
  if (Notification.permission === 'denied') {
    console.log('Permissão de notificação foi negada. Por favor, habilite nas configurações do navegador.');
    return false;
  }
  
  const permission = await Notification.requestPermission();
  return permission === 'granted';
};

export const registerFCMToken = async (userId: number, skipPermissionCheck: boolean = false): Promise<string | null> => {
  try {
    // Garantir que o service worker está registrado primeiro
    if (!serviceWorkerRegistration) {
      const registration = await registerServiceWorker();
      if (!registration) {
        return null;
      }
    }
    
    if (!messagingInstance) {
      console.log('🔥 Inicializando Firebase...');
      await initFirebase();
    }
    
    // Verificar permissão apenas se não foi pulada (já foi verificada antes)
    if (!skipPermissionCheck) {
      const hasPermission = await requestNotificationPermission();
      if (!hasPermission) {
        console.log('⚠️ Permissão de notificação negada');
        return null;
      }
    } else {
      // Verificar se já tem permissão sem solicitar
      const currentPermission = getNotificationPermission();
      if (currentPermission !== 'granted') {
        console.log('⚠️ Permissão de notificação não está concedida');
        return null;
      }
    }
    
    // Aguardar o service worker estar pronto
    const registration = serviceWorkerRegistration || await navigator.serviceWorker.ready;
    
    // Tentar obter token sem VAPID key primeiro (Firebase pode usar configuração padrão)
    let token: string | null = null;
    try {
      token = await messagingInstance.getToken({
        serviceWorkerRegistration: registration,
      });
    } catch (error) {
      console.error('Erro ao obter token FCM:', error);
      // Tentar com VAPID key se disponível
      const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY;
      if (vapidKey && vapidKey !== 'YOUR_VAPID_KEY') {
        try {
          token = await messagingInstance.getToken({
            vapidKey,
            serviceWorkerRegistration: registration,
          });
        } catch (error2) {
          console.error('Erro ao obter token FCM com VAPID:', error2);
        }
      }
    }
    
    if (token) {
      console.log('Token FCM obtido:', token.substring(0, 30) + '...');
      // Registrar token no backend
      try {
        const response = await fetch(`${API_URL}/device-tokens`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify({
            token,
            platform: 'web',
          }),
        });
        
        if (response.ok) {
          console.log('✅ Token FCM registrado no backend com sucesso');
        } else {
          const errorData = await response.json();
          console.error('❌ Erro ao registrar token FCM:', errorData);
        }
      } catch (error) {
        console.error('❌ Erro ao registrar token FCM no backend:', error);
      }
      
      return token;
    } else {
      console.warn('⚠️ Não foi possível obter token FCM');
    }
    
    return null;
  } catch (error) {
    console.error('Erro ao registrar token FCM:', error);
    return null;
  }
};

export const setupForegroundMessageHandler = (callback: (payload: any) => void) => {
  if (!messagingInstance) {
    return;
  }
  
  // IMPORTANTE: Quando em foreground, o FCM chama onMessage
  // O Firebase NÃO deve mostrar notificações automaticamente aqui
  // Apenas processar o payload e mostrar toast
  messagingInstance.onMessage(async (payload: any) => {
    // IMPORTANTE: NÃO criar notificação nativa aqui
    // O Firebase pode tentar mostrar automaticamente se o payload tiver 'notification'
    // Mas como estamos em foreground, o Firebase não mostra automaticamente
    // Apenas chamar o callback para mostrar toast
    callback(payload);
  });
};
